import { useQuery } from '@tanstack/react-query'
import { defaultLocale, Locale } from '@chilipiper/locale'
import { post } from '@chilipiper/service/src/api'
import { getDomain } from '@chilipiper/utils'

type BookMeSettingsParameters =
  | {
      eventOrReportId: string
    }
  | { templateId: string }
  | { workspaceId?: string }

export const useEnabledLanguages = (parameters: BookMeSettingsParameters) => {
  const domain = getDomain()
  const { data, isError, isLoading } = useQuery({
    queryKey: ['book-me-settings', parameters],
    queryFn: () => {
      return post(`book-me/settings/${domain}`, {
        json: parameters,
      }).json<{ enabledLanguages: Locale[] }>()
    },
    enabled: domain !== undefined,
  })

  return { enabledLanguages: isError ? [defaultLocale] : data?.enabledLanguages, isLoading }
}
